require('./up-button.less');

(function() {
    let body = $('html, body');
    let scrollTop = $('.scrolltop');
    let contStyleName = '.scrolltop__container';

    body.on('mouseenter', contStyleName, function() {
        $(this)
            .stop()
            .animate({ opacity: '0.75' }, 200);
    });

    body.on('mouseleave', contStyleName, function() {
        $(this)
            .stop()
            .animate({ opacity: '0.35' }, 200);
    });

    body.on('click', contStyleName, function() {
        body.animate({ scrollTop: 0 }, 300);
        return false;
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > ((screen.height / 2) | 0)) {
            scrollTop.show();
            $(contStyleName)
                .stop()
                .animate({ opacity: '0.35' }, 600);
            return;
        }

        $(contStyleName)
            .stop()
            .animate({ opacity: '0' }, 600);
        scrollTop.fadeOut(600, function() {
            scrollTop.hide();
        });
    });
})();



// WEBPACK FOOTER //
// ./blocks/up-button/up-button.js